<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <div class="row">
            <div class="col-xl-2 col-md-2 col-xs-12 col-sm-12 offset-xl-10 mt-1 ">
                <div class="wrapper input-group">

                    <button class="btn btn-light " @click="advancedSearch()"><i class="fa fa-align-justify"></i>
                        Busca avançada</button>
                </div>
            </div>
        </div>
        <div class="row mt-3" v-show="advanced_search">
           <div class="col-xl-12 col-md-12 col-xs-12 col-sm-12">
                <fieldset>
                    <div class="row">
                        <div class="col-xl-12 col-md-12 col-xs-12 col-sm-12">
                            <label for="">Descrição</label>
                            <input type="text" id="description" class="form-control" placeholder="Ex: Vídeo exemplo"
                                v-model="advanced_search_input.description">
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-xl-12 col-md-12 col-xs-12 col-sm-12">
                            <label for="">Categoria</label>
                            <input type="text" id="category" class="form-control" placeholder="Ex: Vídeo Tutorial"
                                v-model="advanced_search_input.category">
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-xl-12 col-md-12 col-xs-12 col-sm-12">
                            <button class="btn btn-info" @click="executeAdvancedSearch()"> <i
                                    class="fas fa-search fa-sm"></i> Pesquisar</button>
                            <button class="btn btn-danger ml-2" @click="cleanAdvancedSearch()"> <i
                                    class="fas fa-times fa-sm"></i> Limpar</button>
                        </div>

                    </div>
                </fieldset>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="card card-table shadow mb-4">
                    <!-- Card Header - Dropdown -->
                    <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                        <h6 class="m-0 font-weight-bold text-primary">Links <small><span
                                    v-if="total_itens > 0">| Total registros encontrados: {{ formatDecimal(total_itens)
                                    }}</span></small><br>
                        </h6>
                        <button class="btn btn-warning btn-sm" @click="loadData()"><i class="fa fa-undo"></i>
                            Recarregar dados</button>
                    </div>
                    <div class="card-body" :class="links.length <=0? 'card-body-no-spaccing':''">
                        <div class="table-responsive">
                            <table class="table" id="dataTable" width="100%" cellspacing="0">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Descrição</th>
                                        <th>Categoria</th>
                                        <th class="text-center">Link</th>
                                        <th class="text-center">Data Expiração</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(link, index) in links" :key="link.id">
                                        <td class="pointer" @click="openModalViewlink(link)">{{ index +
                                            1 }}</td>
                                         <td class="pointer" @click="openModalViewlink(link)">
                                            {{ link.description }} <span v-if="link.observation != ''" class="badge badge-warning">Comentário</span> </td>
                                        <td class="pointer" @click="openModalViewlink(link)">
                                            {{ link.category }} </td>
                                        <td class="text-center"><a :href="link.url" class="btn btn-link" target="_blank">Abrir</a></td>
                                        <td class="text-center">{{ link.expiration ? link.expiration_formatted : '-' }} <div v-if="link.expired_link"><span  class="badge badge-danger">Expirado</span></div></td>
                                    </tr>
                                    <tr v-if="links.length > 0 && page > 1">
                                        <td colspan="6" class="align-middle text-center pt-5"> <button
                                                @click="loadData()" class="btn btn-info btn-sm"
                                                :disabled="!buttonPagination"><i class="fa fa-spinner"></i> Carregar
                                                mais registros</button></td>
                                    </tr>
                                    <tr v-show="links.length <= 0">
                                        <td colspan="6" class="text-center">Nenhum link encontrado</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  <div id="modalDisplayViewlink" class="modal" :style="{ display: modalDisplayViewlink }">
        <div class="row">
            <div class="col-lg-12 col-sm-12 col-xs-12">
                <form>
                    <div class="modal-content">
                    
                        <div class="modal-header">
                            <h5 class="modal-title" id="newFileLabel">Comentários</h5>
                            <button type="button" class="close" @click="closeModallink()">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row mt-2">
                                <div class="col-xl-12 col-md-12 col-sm-12">
                                    <editorTextDisabled @update-text="updateObservation" :modelValue="link.observation"
                                         ref="myChild">
                                    </editorTextDisabled>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger" @click="closeModallink()">Fechar</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';
import Loading from 'vue-loading-overlay';
import editorTextDisabled from '../util/editor-text-disabled.vue';

import 'vue-loading-overlay/dist/css/index.css';

export default {
    components: { Loading, editorTextDisabled },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            advanced_search: false,
            advanced_search_input: {},
            links: [],
            page: 1,
            last_page: 1,
            total_itens: 0,
            modalDisplayViewlink: 'none',
            modalDisplayViewClientlink: 'none',
            link: {
                id: '',
                description: '',
                category: '',
                url: '',
                observation: ''
            },
          
        }
    },
    computed: {
        buttonPagination: function () {
            return this.page > 1;
        },

    },
    methods: {
        onCancel() { },
        advancedSearch() {
            this.advanced_search = !this.advanced_search
        },
        closeAdvancedSearch() {
            this.advanced_search = false
        },

       
        executeAdvancedSearch() {
            this.page = 1;
            this.links = {};
            this.loadData();
        },
        cleanAdvancedSearch() {
            this.links = {}
            this.advanced_search_input = {}
            this.loadData();
        },
        loadData() {
            this.isLoading = true;
            api.get('/link-user', {
                params: {
                    'description': this.advanced_search_input.description,
                    'category': this.advanced_search_input.category,
                    'page': this.page
                }
            })
                .then((response) => {
                    console.log(response);
                    this.isLoading = false;
                    this.last_page = response.data.last_page;
                    if (this.page <= 1) {
                        this.links = response.data.data;
                    } else {
                        this.links = this.links.concat(response.data.data);
                    }

                    if (this.page < response.data.last_page) {
                        this.page++;
                    } else {
                        this.page = 1;
                    }

                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status);
                })
        },

        update(event) {
            event.preventDefault();
            this.isLoading = true;
            api.put('/link-client/' + this.link.id, this.link)
                .then(() => {
                    this.isLoading = false;
                    this.$notify({
                        title: "Sucesso",
                        text: "Link atualizado com sucesso!",
                        type: 'success'
                    });
                    this.closeModallink();
                    this.loadData();
                }).catch(error => {
                    this.isLoading = false;
                    if (error.status == 422) {
                        let response_errors = error.response.data.errors;
                        this.errors = response_errors;
                        this.enable_error_list = true;
                    }
                    handleRequestErrors(error.status, error);
                })
        },

        updateListClient(event) {
            event.preventDefault();
            this.isLoading = true;
            let clients_selected = JSON.stringify(this.client_selected);
            const formData = new FormData();
            formData.append('clients', clients_selected);
            api.post('/link-client/' + this.link.id + '/clients', formData)
                .then(() => {
                    this.isLoading = false;
                    this.$notify({
                        title: "Sucesso",
                        text: "Lista de clientes atualizada com sucesso!",
                        type: 'success'
                    });
                    this.client_selected = [];
                    this.closeModalClientlink();
                    this.loadData();
                }).catch(error => {
                    this.isLoading = false;
                    if (error.status == 422) {
                        let response_errors = error.response.data.errors;
                        this.errors = response_errors;
                        this.enable_error_list = true;
                    }
                    handleRequestErrors(error.status, error);
                })
        },

        removeClientList(element) {
            const index = this.client_selected.findIndex(item => item.key === element);
            if (index > -1) {
                this.client_selected.splice(index, 1);
            }

        },

        openModalViewlink(link) {
            this.link.id = link.id;
            this.link.url = link.url;
            this.link.description = link.description;
            this.link.category = link.category;
            this.link.observation = link.observation;
            this.$refs.myChild.updateTextEditor(this.link.observation);
            this.modalDisplayViewlink = 'block';
            this.isLoading = false;

        },
        closeModallink(value) {
            this.modalDisplayViewlink = value;
        },

        async getclients() {
            this.loading = true;
            const response = await api.get('/client', { params: { 'all_clientes': true, 'status': 'Ativo' } })
                .then((response) => {
                    this.clients = response.data.data;
                    this.loading = false;
                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status, error);
                });
            return response;

        },

        inListClientSelected(key) {
            let inserted = false;
            this.client_selected.forEach(client => {
                if (client.key == key) {
                    inserted = true;
                }
            });
            return inserted;
        },

        clientWithLang({ value }) {
            return value;
        },

        deletelink(id) {
            this.$confirm(
                {
                    message: 'Deseja apagar o link?',
                    button: {
                        no: 'Não',
                        yes: 'Sim'
                    },

                    callback: confirm => {
                        if (confirm) {
                            this.isLoading = true;
                            api.delete('/link-client/' + id)
                                .then(() => {
                                    this.isLoading = false;
                                    this.$notify({
                                        title: "Sucesso",
                                        text: "Link excluído com sucesso",
                                        type: 'success'
                                    });
                                    this.page = 1;
                                    this.loadData();
                                }).catch(error => {
                                    this.isLoading = false;
                                    handleRequestErrors(error.status);
                                })
                        }
                    }
                }
            )
        }
    },
    mounted() {
        this.loadData();
    },
}
</script>

<style>
.pointer {
    cursor: pointer;
}

.modal {
    position: fixed;
    z-index: 1999;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgb(0, 0, 0);
    background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
    background-color: #f5f5f5;
    margin: 3% auto;
    padding: 20px;
    border: 1px solid #888;
    width: 65%;
}

.modal-header {
    color: #000;
}

.close {
    color: #aaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
}

.close:hover,
.close:focus {
    color: black;
    text-decoration: none;
    cursor: pointer;
}


@media (max-width: 576px) {
    .modal-content {
        width: 90% !important;
    }
}
</style>